class BannerHome {
	constructor() {
		this.banner = document.querySelector(".banner.banner-home");

		if(!this.banner) {
			return;
		}

		this.buildSliders();
	}

	buildSliders() {
		this.sliderContainer = this.banner.querySelector('.banner-home-slider-text');
		if (!this.sliderContainer) {
			return;
		}
		this.sliderNav = this.banner.querySelector(".banner-home-slider-nav");
		this.images = this.banner.querySelectorAll(".banner-home-slider-image .slide-image");
		const nextBtn = this.banner.querySelector(".swiper-next");
		const prevBtn = this.banner.querySelector(".swiper-prev");

		this.slider = new Swiper(this.sliderContainer, {
			allowTouchMove: false,
			autoplay: {
				delay: 4000
			},
			loop: true,
			speed: 0,
			effect: "creative",
			creativeEffect: {
				prev: {
					translate: [0, "-30%", 0],
				},
				next: {
					translate: [0, "30%", 1],
				},
			},
			navigation: {
				nextEl: nextBtn,
				prevEl: prevBtn,
			},
			on: {
				init: (slider) => {
					const firstImage = this.banner.querySelector(".slide-image.ready");
					firstImage.classList.add("active");

					gsap.to(firstImage, {
						autoAlpha: 1,
						duration: 1.5,
						ease: "power1.in",
						onComplete: () => {
							firstImage.classList.remove("ready");
						}
					});

				},
				afterInit: (slider) => {
					setTimeout(() => {
						this.banner.querySelectorAll(".banner-home-slider-text .swiper-slide").forEach(slide => {
							slide.classList.add("transition-enabled");
						});
					}, 500);

				},
				slideChangeTransitionStart: (swiper) => {
					this.images.forEach(image => {
						image.classList.remove("active");
					});
					const activeImage = this.banner.querySelector(".slide-image:not(.ready)[data-index='" + swiper.realIndex + "']");
					if (activeImage) {
						activeImage.classList.add("active");
					}

					this.sliderNav.querySelectorAll("li").forEach(li => {
						li.classList.remove("active");
					});
					this.sliderNav.querySelector("li[data-index='" + swiper.realIndex + "']").classList.add("active");
				}
			},
		});

		const slidesLinks = this.sliderNav.querySelectorAll("li");
		slidesLinks.forEach(link => {
			link.addEventListener("click", () => {
				this.slider.slideTo(link.dataset.action);
				this.slider.autoplay.start();
			});
		});

		nextBtn.addEventListener("click", () => {
			this.slider.autoplay.start();
		});
		prevBtn.addEventListener("click", () => {
			this.slider.autoplay.start();
		});
	}
}